export const API = {
  LOGIN: 'auth/login',
  SIGNUP: 'auth/signup',
  PROFILE: 'users/me',
  TOPUP: 'wallet/topup',
  WITHDRAW: 'wallet/withdraw',
  REFERRALS: 'users/me/referrals',
  WALLET: 'wallet',
  NEWS: 'news',
  SUPPORT: 'support/tickets',
  ADMIN_USERS: 'admin/users',
  TODAY_USERS: 'admin/users/today',
} as const;

export const ADMIN_API = {
  LOGIN: 'Admin/Index',
  DASHBOARD: 'Admin/Dashboard',
  PROFILE: 'Admin/Profile',
  PROFILE_UPDATE: 'Admin/Profile_Update',
  TODAY_ACTIVE: 'Admin/Today_Active',
  TODAY_JOINS: 'Admin/Today_joins',
  TOTAL_USERS: 'Admin/Total_users',
  TOTAL_MEMBERS: 'Admin/Total_Members',
  TOTAL_ACTIVE_USERS: 'Admin/Total_Activeusers',
  TOTAL_INACTIVE_USERS: 'Admin/Total_Inactiveusers',
  USER_BY_ID: 'Admin/Get_Userdatabyid',
  USER_BY_REG_ID: 'Admin/Get_Userdatabyregid',
  USER_PROFILE_UPDATE: 'Admin/Userprofile_Update',
  WITHDRAW_USERS: 'Admin/Withdraw_users',
  ADD_NEWS: 'Admin/Add_News',
  GET_NEWS: 'Admin/Get_News',
  WALLET_DEDUCT: 'Admin/Wallet_Deduct',
  WALLET_DEDUCTION_REPORT: 'Admin/Wallet_deductionreport',
  ADD_MISCELLANEOUS: 'Admin/AddMiscellaneous',
  GET_MISCELLANEOUS: 'Admin/Get_Miscellaneous',
  MISCELLANEOUS_UPDATE: 'Admin/Miscellaneous_update',
  WALLET_REPORT: 'Admin/Wallet_Report',
} as const;

export const USER_API = {
  LOGIN: 'User/Index',
  REGISTER: 'User/Register',
  PROFILE: 'User/Profile',
  HOME: 'User/Home',
  ANALYTICS: 'User/Analytics',
  PROFILE_UPDATE: 'User/Profile_Update',
  DIRECT_TEAM: 'User/Directteam',
  USER_BY_REG_ID: 'User/Get_Userdatabyregid',
  ACTIVATE_TOKEN_PACKET: 'User/Activate_Tokenpacket',
  TOPUP_TOKEN_PACKET: 'User/Topup_Tokenpacket',
  TOPUP_WALLET: 'User/Topup_Wallet',
  ACTIVATE_WALLET: 'User/Activate_Wallet',
  TOPUP_WALLET_SPLIT: 'User/Topup_Walletsplit',
  ACTIVATION_DATA: 'User/Activation_data',
  FORGET_PASSWORD: 'User/Forget_password',
  PAYOUT: 'User/Bitrazepayout',
  LEVEL_MEMBERS: 'User/Level_members',
  WALLET_REPORT: 'User/Wallet_Report',
  NEWS: 'User/Get_News',
  ADD_SUPPORT_TOKEN: 'User/Add_Supporttoken',
  SUPPORT_TOKENS: 'User/User_Supporttokens',
  WALLET_TODAY_REPORT: 'User/Wallet_TodayReport',
  COMPLETED_WITHDRAW_REQUESTS: 'User/Withdrawrequestdata_complete',
} as const;
